import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Code client (Reference Externe)', 'tiersId', true),
  new ColumnExcel('Code Contact (Reference Externe)', 'contactId', true),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplateContactTiers.xlsx',
    [
      new SheetExcel(
        'ContactsTiers',
        columns,
        data,
        { skipHeader: false },
      ),
    ],
  );
}

export function generatedTemplateContactTiers() {
  const exemple = {
    tiersId: 'C1994',
    contactId: 'F1244',
  };
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}
